"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _Builder = _interopRequireDefault(require("./Builder"));
var _settings = require("./Builder/settings.js");
var _Player = _interopRequireDefault(require("./Player"));
var _settings2 = require("./Player/settings.js");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var _default = exports["default"] = {
  code: 'dragdrop',
  name: 'Drag & drop',
  labelField: 'question',
  icon: _settings.icon,
  builder: _Builder["default"],
  builderInitialValues: _settings.initialValues,
  player: _Player["default"],
  getMetrics: _settings.getMetrics,
  getDataDefinitions: _settings.getDataDefinitions,
  onBeforeNextPage: _settings2.onBeforeNextPage,
  getDataConnectors: _settings.getDataConnectors,
  getDataConnectorsValues: _settings.getDataConnectorsValues,
  ttsFields: _settings.ttsFields,
  hasPrintVersion: true
};